<template>
  <v-card>
    <v-form>
      <v-card-title>
        {{title}}
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col
              v-for="(field, index) in fieldsList"
              :key="index"
              :cols="field.cols || 6"
            >
              <v-autocomplete
                v-if="field.type==='select'"
                v-model="form[field.name]"
                :items="field.items"
                :label="field.label"
                :item-value="field.value"
                :item-text="field.text"
                dense
                outlined
                :chips="field.multiple"
                :multiple="field.multiple"
                :small-chips="field.multiple"
                @change="$v.form[field.name].$touch()"
                :error-messages="errorMessages(field.name)"
              >
                <template v-slot:item="{ item }">
                  <v-list-item-content :key="field.value ? item[field.value] : item">
                    <v-list-item-title>{{field.text ? item[field.text] : item}}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
              <v-text-field
                v-else-if="field.type==='text'"
                v-model="form[field.name]"
                :label="field.label"
                dense
                outlined
                @input="$v.form[field.name].$touch()"
                :error-messages="errorMessages(field.name)"
              />
              <UserSelect
                v-if="field.type==='users'"
                :form="form"
                :label="field.label"
                multiselect
                @change="$v.form[field.name].$touch()"
                :error-messages="errorMessages(field.name)"
              />
              <UserSelect
                v-if="field.type==='user'"
                :form="form"
                :label="field.label"
                @change="$v.form.user.$touch()"
                :error-messages="errorMessages('user')"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-spacer />
            <v-col cols="3">
              <v-btn
                rounded
                dark
                dense
                block
                outlined
                color="primary"
                @click="cancel"
              >
                {{ $t('common.cancel') }}
              </v-btn>
            </v-col>
            <v-col cols="3">
              <SubmitButton block @click="submit" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { errorMessageGenerator } from '@/validators'

export default {
  name: 'DictionaryForm',
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    title: String,
    fields: Object,
    validationModel: Object
  },
  data () {
    return {
      form: this.value,
      fieldsConfig: {
        users: {
          label: this.$tc('dictionaries.user', 2),
          type: 'users',
          cols: 12
        },
        user: {
          label: this.$tc('dictionaries.user', 1),
          type: 'user',
          cols: 6
        },
        project: {
          label: this.$tc('contract.project.OFF', 1),
          type: 'select',
          text: 'name',
          value: 'id',
          cols: 6
        },
        name: {
          label: this.$t('common.name'),
          type: 'text'
        },
        area: {
          label: this.$tc('contract.area', 1),
          type: 'select',
          multiple: false,
          text: 'name',
          value: 'code'
        },
        areas: {
          label: this.$tc('contract.area', 2),
          type: 'select',
          multiple: true,
          text: 'name',
          value: 'code'
        },
        code: {
          label: this.$t('dictionaries.code'),
          type: 'text'
        },
        symbol: {
          label: this.$t('dictionaries.symbol'),
          type: 'text'
        },
        type: {
          label: this.$tc('dictionaries.type', 1),
          type: 'select',
          multiple: false
        }
      }
    }
  },
  computed: {
    fieldsList () {
      const techFields = ['createdAt', 'updatedAt', 'id']
      return Object.keys(this.value).filter(i => !techFields.includes(i)).map(i => {
        return {
          ...this.fieldsConfig[i],
          name: i,
          ...this.fields[i]
        }
      })
    }
  },
  methods: {
    errorMessages (key) {
      return errorMessageGenerator(this.$v.form[key], key)
    },
    async submit () {
      this.$v.form.$touch()
      if (!this.$v.form.$invalid) {
        this.$emit('SAVE', this.form)
        this.$v.$reset()
        this.form = {}
        this.$eventBus.$emit('CLOSE_MODAL')
      }
    },
    cancel () {
      this.$v.$reset()
      this.form = {}
      this.$eventBus.$emit('CLOSE_MODAL')
    }
  },
  watch: {
    value: {
      deep: true,
      handler (v) {
        this.form = v
      }
    }
  },
  validations () {
    return this.validationModel
  }
}
</script>
